import React from "react";
import Checkout from "../components/Checkout/Checkout";

export default function CheckoutPage() {
  return <Checkout />;
}